var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTutorialsSolid = function SvgTutorialsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.278.304a.75.75 0 0 0-.556 0l-10 4a.75.75 0 0 0 0 1.392L4.25 7.108V12c0 1.223.954 2.183 2.172 2.792 1.253.626 2.9.958 4.578.958 1.678 0 3.325-.332 4.578-.958 1.218-.61 2.172-1.569 2.172-2.792V7.108l2.5-1V11a.75.75 0 0 0 1.5 0V5a.75.75 0 0 0-.471-.696l-10-4ZM5.75 7.217v-.034a.748.748 0 0 1 1.029-.68L11 8.194l4.222-1.69a.75.75 0 0 1 1.028.68v.034a.75.75 0 0 1-.472.68l-4.5 1.8a.75.75 0 0 1-.556 0l-4.5-1.8a.75.75 0 0 1-.472-.68Z",
    fill: "currentColor"
  })));
};
export default SvgTutorialsSolid;